module.exports = __webpack_public_path__ + "img/dloons_02.0cb2a36d.png";